<i class="fas fa-lg fa-fw" *ngIf="!imageURL" [class]="iconClass"></i><img class="fa-lg fa-fw icon" *ngIf="imageURL" [src]="imageURL" [alt]="imageAltText">